import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QSMediaComponent } from './quickstart-media.component';
import { QSMediaSelectRoomComponent } from './select-room/select-room.component';
import { QSMediaSelectMediaComponent } from './select-media/select-media.component';
import { QSMediaSelectRemoteComponent } from './select-remote/select-remote.component';

export const QUICKSTART_ACTIONS_MEDIA_ROUTES: Routes = [
  {
    path: 'media',
    component: QSMediaComponent,
    children: [
      {
        path: 'remotes',
        component: QSMediaSelectRemoteComponent
      },
      {
        path: ':source',
        component: QSMediaSelectRoomComponent
      },
      {
        path: ':source/:roomId',
        component: QSMediaSelectMediaComponent
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-media/quickstart-media.routes.ts